// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"222":"47443a9d","567":"79bb9c92","761":"2da548bf","925":"e2d6f0e3"}[chunkId] + ".chunk.css");